// String/BigInt formatting so exact decimals from the server are never rounded by floats.
export const groupDigits = (value) => {
  const [int, frac] = String(value ?? "0").split(".");
  const neg = int.startsWith("-");
  const digits = (neg ? int.slice(1) : int).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${neg ? "-" : ""}${digits}${frac !== undefined ? "." + frac : ""}`;
};

// Rule 12: values are stored exactly; round half-up to cents for display only.
export const roundCents = (value) => {
  let s = String(value ?? "0").trim() || "0";
  const neg = s.startsWith("-");
  if (neg) s = s.slice(1);
  const [int, frac = ""] = s.split(".");
  const f = frac.padEnd(3, "0");
  let cents = BigInt(int || "0") * 100n + BigInt(f.slice(0, 2));
  if (Number(f[2]) >= 5) cents += 1n;
  const out = `${cents / 100n}.${String(cents % 100n).padStart(2, "0")}`;
  return neg && cents !== 0n ? `-${out}` : out;
};

export const formatAUD = (value) => {
  const r = roundCents(value);
  return r.startsWith("-") ? `-$${groupDigits(r.slice(1))}` : `$${groupDigits(r)}`;
};

export const formatMoney = (value) => (value == null || value === "" ? "" : formatAUD(value));

export const isNegative = (value) => roundCents(value).startsWith("-");

// Exact sum of decimal strings (used for grid footers).
export const sumDecimals = (values) => {
  const list = values.filter((v) => v != null && v !== "").map(String);
  const scale = Math.max(0, ...list.map((v) => (v.split(".")[1] || "").length));
  const total = list.reduce((acc, v) => {
    const neg = v.startsWith("-");
    const [i, f = ""] = (neg ? v.slice(1) : v).split(".");
    const n = BigInt((i || "0") + f.padEnd(scale, "0"));
    return acc + (neg ? -n : n);
  }, 0n);
  const neg = total < 0n;
  const digits = (neg ? -total : total).toString().padStart(scale + 1, "0");
  const out = scale ? `${digits.slice(0, -scale)}.${digits.slice(-scale)}` : digits;
  return neg ? `-${out}` : out;
};

export const formatTime = (iso) =>
  new Date(iso).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" });

export const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const DECIMAL_RE = /^-?\d+(\.\d+)?$/;
